<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <ArenaVehicleTypeForm />
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ArenaVehicleTypeForm from '@/components/settings/arena/vehicle-type/ArenaVehicleTypeForm'

export default {
  name: 'ArenaVehicleTypeAdd',
  components: {
    PageTitle,
    PageRowWrapper,
    ArenaVehicleTypeForm
  }
}
</script>
